var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 19.2a2.4 2.4 0 002.4 2.4h17.6a2.4 2.4 0 002.4-2.4H4.8v0zM27.2 19.2V8a2.4 2.4 0 00-2.4-2.4H7.2A2.4 2.4 0 004.8 8v11.2h22.4v0zM18 21.6l1.078 2.587A1.6 1.6 0 0117.6 26.4h-3.2a1.605 1.605 0 01-1.478-.987 1.607 1.607 0 010-1.226L14 21.6h4z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.8A2.4 2.4 0 1016 8a2.4 2.4 0 000 4.8zM13.6 17v2.2h4.8V17v2.2h2.4v-3.4a2.4 2.4 0 00-2.4-2.4 3.398 3.398 0 01-3.699.735c-.4-.165-.774-.41-1.1-.735a2.4 2.4 0 00-2.4 2.4v3.4h2.4V17v0z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMan);
export default __webpack_public_path__ + "static/media/monitor-man.c577228da7b300cc68fe0d1615a43447.svg";
export { ForwardRef as ReactComponent };